import { PageNotFound } from '@crehana/compass.ui/page-not-found';

const WhatsappTemplatesProductNotFound = () => {
  return <PageNotFound />;
};

export default WhatsappTemplatesProductNotFound;
